import React from 'react';

interface RecordingsScreenProps {
  isDarkMode: boolean;
}

const RecordingsScreen: React.FC<RecordingsScreenProps> = ({ isDarkMode }) => {
  const containerStyle: React.CSSProperties = {
    padding: '2rem',
    backgroundColor: isDarkMode ? '#111827' : '#ffffff',
    minHeight: 'calc(100vh - 4.375rem)',
    color: isDarkMode ? '#e5e7eb' : '#1f2937',
  };

  const titleStyle: React.CSSProperties = {
    fontSize: '2rem',
    fontWeight: '700',
    marginBottom: '1rem',
  };

  const descriptionStyle: React.CSSProperties = {
    fontSize: '1rem',
    color: isDarkMode ? '#9ca3af' : '#6b7280',
  };

  return (
    <div style={containerStyle}>
      <h1 style={titleStyle}>Session Recordings</h1>
      <p style={descriptionStyle}>
        Review and analyze your trading session recordings.
      </p>
    </div>
  );
};

export default RecordingsScreen;
